import { type ReactNode, useEffect, useRef } from 'react';
import { ModalContentWrapper } from './ModalContentWrapper';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export function Modal({ open, onClose, title, children }: Props) {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const firstFocusable = modalRef.current?.querySelector<HTMLElement>(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    firstFocusable?.focus();
  }, [open]);

  return (
    <ModalContentWrapper
      open={open}
      onClose={onClose}
      title={title}
      modalScrollRef={modalRef}
      classes={{ children: 'p-5' }}
    >
      {children}
    </ModalContentWrapper>
  );
}
